import React from 'react';
import SuccessCheckCircleSvg from '../../assets/images/check_circle_24px.svg'

function SuccessCheckCircleIcon(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <img src={SuccessCheckCircleSvg} alt="SuccessCircle" {...props} />
  );
}

export default SuccessCheckCircleIcon;
